import React from 'react';
import { Outlet } from 'react-router';

import { Layout} from 'antd';

import AdminSider from '../../Pages/AdminHome/Component/AdminSider';
import AdminFooter from '../../Pages/AdminHome/Component/AdminFooter';

const { Content} = Layout;

function WithSideNav(){

    return(
        <div className="WithSideNav">
            <Layout style={{ minHeight: '100vh' }}>
                <AdminSider/>
                <Content>
                    <Layout className="site-layout-background" style={{ minHeight: '100vh',}}>
                        <Content>
                            <div style={{ margin: '20px 50px' }}> 
                                <Outlet/>
                            </div>
                        </Content>
                        <AdminFooter/>
                    </Layout>
                </Content>
            </Layout>
        </div>
    )
}

export default WithSideNav;